var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.666 5a3.333 3.333 0 1 1 .8 2.167l-4.2 2.164a3.35 3.35 0 0 1 0 1.339l4.2 2.164a3.333 3.333 0 1 1-.733 1.497l-4.2-2.164a3.333 3.333 0 1 1 0-4.333l4.2-2.164a3.4 3.4 0 0 1-.067-.67m-5.14 5.67a1 1 0 0 0-.05.107 1.667 1.667 0 1 1 0-1.553 1 1 0 0 0 .05.107 1.66 1.66 0 0 1 0 1.338Zm6.947 3.661a1.667 1.667 0 1 0 .052-.107 1 1 0 0 1-.052.107M15 6.667c-.64 0-1.196-.361-1.475-.89a1 1 0 0 0-.052-.108A1.667 1.667 0 1 1 15 6.667",
    clipRule: "evenodd"
  })));
};
export default SvgShare;